import React from "react";
import MessageService from "../services/messages";
import UserService from "../services/users";
import MessageList from "../components/messages/messagelist";
import ClientService from "../services/clients";

import Search from "../components/general/search";
import MessageEdit from "../components/messages/messageedit";
import ActionButton from '../components/layout/actionButtons';
import { IconButton } from "@material-ui/core";

import DeleteIcon from '@material-ui/icons/Delete';


class Messages extends React.Component {
  constructor(props) {
    super(props);
    this.state = { items: [], filterItems: [], item: undefined, readOnly: true };
  }

  componentDidMount() {
    let deleteButton = <IconButton onClick={()=>{window.confirm("Weet u zeker dat u dit bericht wilt verwijderen?") && this.handleDelete(this.state.item)}}><DeleteIcon style={{color:'FFF'}}/></IconButton>


    UserService.validSecuritySession()
      .then(
        (result) => {

        }, (error) => {
          this.props.history.push('/login');
        })

    const currentUser = UserService.currentUser();
    this.getItems();

    if (!this.props.match.params.id) {
      let actionButtons;

      if (currentUser.adminmodules.find(mod => { return mod === 'messages' }) !== undefined) {
        actionButtons = <ActionButton {...this.props} linkNewItem='/messages/0'></ActionButton>
        this.setState({ readOnly: false });
      }

      this.props.handleMenu(
        {
          title: 'Berichten',
          handleActions: actionButtons
        })

    } else {
      if (this.props.match.params.id === '0') {
        this.setState({ item: {} })
      } else {
        MessageService.get(this.props.match.params.id).then(
          (result) => {
            this.setState({ item: result });
          },
          (err) => {
            this.props.handleMessage({ title: "Kan de gegevens niet ophalen" });
            this.props.history.push('/messages')
          }
        )
      }


      let actionButtons;

      if (currentUser.adminmodules.find(mod => { return mod === 'messages' }) !== undefined) {
        actionButtons = <ActionButton {...this.props} handleSave={this.handleSave} itemleft={<React.Fragment>{deleteButton}</React.Fragment>}></ActionButton>
        this.setState({ readOnly: false });
      }
      this.props.handleMenu(
        {
          title: 'Berichten',
          showBackButton: true,
          handleActions: actionButtons
        })
    }
  }

  getItems() {
    MessageService.get().then(
      messages => {
        this.setState({ items: messages, filterItems: messages });

      },
      error => {
        console.log("error", error);
      }
    );
  }

  handleUpdate = (item) => {
    this.setState({ item: item });
  }

  handleSave = () => {
    let item = this.state.item;
    if (item.title) {
      let tmpObject = Object.assign({}, item);
      tmpObject.lastModified = new Date();
      tmpObject.read = [];
      MessageService.save(tmpObject).then(
        result => {
          this.props.history.push('/messages')
        },
        error => {
          this.props.handleMessage({ title: "Het opslaan is mislukt" });
        }
      );
    } else {
      this.props.handleMessage({ title: "Gegevens zijn niet compleet" });
    }
  }

  handleDelete(item) {
    MessageService.delete(item._id).then(
      result => {
        this.props.history.push('/messages');
      },
      error => {
        this.props.handleMessage({ title: "Fout bij het verwijderen." });
      }
    );
  }

  handleEdit = (item) => {
    this.props.history.push('/messages/' + item._id);
  }

  handleSearch = (search) => {
    let filterItems = this.state.items;
    filterItems = filterItems.filter((item) => { return (JSON.stringify(item).toLowerCase().indexOf(search.toLowerCase()) >= 0) });
    this.setState({ filterItems })
  }
  compare(a, b) {
    if (a.lastModified > b.lastModified)
      return -1;
    if (a.lastModified < b.lastModified)
      return 1;
    return 0;
  }

  render() {
    return (
      <div>
        {
          this.state.item
            ?
            <MessageEdit
              {...this.props}
              item={this.state.item}
              items={this.state.items}
              clients={this.state.clients}
              handleUpdate={this.handleUpdate}
              readOnly={this.state.readOnly}
            />
            :
            <React.Fragment>
              <Search handleSearch={this.handleSearch} />
              <MessageList items={this.state.filterItems.sort(this.compare)} handleClick={this.handleEdit} />
            </React.Fragment>
        }
      </div>
    );
  }
}
export default Messages;
